/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_EnabledInputs */

const vi_shop_home_enabled = /** @type {(inputs: Shop_Home_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bật`)
};

/**

* @param {Shop_Home_EnabledInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_enabled = /** @type {((inputs?: Shop_Home_EnabledInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_EnabledInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_enabled(inputs)
});